export function getIsIndividual(rsc) {
    return (rsc.match("SJP[MW]NH----------------FNL-0001SJ--") 
    || rsc.match("SJP[MW]NH----------------FNL-0002SJ--") 
    || rsc.match("SJP[MW]LH----------------FNL-0001SJ--")
    || rsc.match("SJP[MW]LH----------------FNL-0002SJ--"));
}

export function getIsMixed(rsc) {
    return (rsc.match("SJPXNHTEAM4.+"));
}